import DashboardOverview from "../../pages/dashboard/overview";
// import TransactionIndex from "../../pages/dashboard/transaction";
// import TransactionDetails from "../../pages/dashboard/transaction/transactionDetails";
import UserActivitiesIndex from "../../pages/dashboard/user-activity/UserActivitiesIndex";
import UserIndex from "../../pages/dashboard/users/UserIndex";
import { ALL_ROUTES } from "../AllRoutes";
import { customer_route_group } from "./customerRoutes";
import { export_routes_group } from "./ExportRoutes";
import { feature_management_routes_group } from "./featureMgtRoutes";
import { ledger_routes_group } from "./LedgerRoutes";
import { notification_management_routes_group } from "./NotificationManagementRoutes";
import { rate_intelligence_routes_group } from "./RateIntelligenceRoutes";
import { referral_routes_group } from "./ReferralRoutes";
import { report_routes_group } from "./ReportRoutes";
import { all_roles_routes_group } from "./RolesRoutes";
import { settings_all_routes_group } from "./SettingsRoutes";
import { third_party_route_group } from "./thirdPartyRoutes";
import { transaction_route_group } from "./transactionsRoutes";

export const dashboard_route_group = [
  {
    path: ALL_ROUTES?.DASHBOARD_OVERVIEW,
    element: DashboardOverview,
  },
  {
    path: ALL_ROUTES?.DASHBOARD_USERS,
    element: UserIndex,
  },
  {
    path: ALL_ROUTES?.DASHBOARD_USER_ACTIVITY,
    element: UserActivitiesIndex,
  },
  ...transaction_route_group,
  ...customer_route_group,
  ...settings_all_routes_group,
  ...all_roles_routes_group,
  ...third_party_route_group,
  ...report_routes_group,
  ...feature_management_routes_group,
  ...export_routes_group,
  ...ledger_routes_group,
  ...referral_routes_group,
  ...notification_management_routes_group,
  ...rate_intelligence_routes_group,
];
